import React, { useState, useEffect } from "react";

import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "react-query";
import lightBackground from '../src/assets/wa-background-light.png';
import darkBackground from '../src/assets/wa-background-dark.jpg';
import { ptBR } from "@material-ui/core/locale";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";
import ColorModeContext from "./layout/themeContext";
import { SocketContext, SocketManager } from './context/Socket/SocketContext';

import Routes from "./routes";

const queryClient = new QueryClient();

const App = () => {
    const [locale, setLocale] = useState();

    const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
    const preferredTheme = window.localStorage.getItem("preferredTheme");
    const [mode, setMode] = useState(preferredTheme ? preferredTheme : prefersDarkMode ? "dark" : "light");

    const colorMode = React.useMemo(
        () => ({
            toggleColorMode: () => {
                setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
            },
        }),
        []
    );

    const theme = createTheme(
        {
            scrollbarStyles: {
                "&::-webkit-scrollbar": {
                    width: '8px',
                    height: '8px',
					borderRadius: "8px",
                },
                "&::-webkit-scrollbar-thumb": {
                    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
                    backgroundColor: "#2f0549",
					borderRadius: "8px",
                },
            },
            scrollbarStylesSoft: {
                "&::-webkit-scrollbar": {
                    width: "8px",
					borderRadius: "8px",
                },
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: mode === "light" ? "#F3F3F3" : "#333333",
					borderRadius: "8px",
                },
            },
            palette: {
    type: mode,
    primary: { main: mode === "light" ? "#00539B" : "#ffffff" },
    sair: { main: mode === "light" ? "#003B70" : "#cccccc" },
    vcard: { main: mode === "light" ? "#0074CC" : "#888" },
    textPrimary: mode === "light" ? "#003B70" : "#ffffff",
    borderPrimary: mode === "light" ? "#00539B" : "#ffffff",
    dark: { main: mode === "light" ? "#333333" : "#F3F3F3" },
    light: { main: mode === "light" ? "#F3F3F3" : "#2B2B2B" },
    tabHeaderBackground: mode === "light" ? "#E6F0FA" : "#1F2B38",
    optionsBackground: mode === "light" ? "#FAFAFA" : "#2A2A2A",
    options: mode === "light" ? "#FAFAFA" : "#3C3C3C",
    fontecor: mode === "light" ? "#0074CC" : "#B3D4FF",
    fancyBackground: mode === "light" ? "#FFFFFF" : "#222",
    bordabox: mode === "light" ? "#E0E0E0" : "#333",
    newmessagebox: mode === "light" ? "#E6F0FA" : "#333",
    inputdigita: mode === "light" ? "#FFFFFF" : "#444",
    contactdrawer: mode === "light" ? "#FFFFFF" : "#3C3C3C",
    announcements: mode === "light" ? "#E6E6E6" : "#333",
    login: mode === "light" ? "#FFFFFF" : "#1A1A1A",
    announcementspopover: mode === "light" ? "#FFFFFF" : "#444",
    chatlist: mode === "light" ? "#F2F7FC" : "#2A2A2A",
    boxlist: mode === "light" ? "#E6F0FA" : "#3C3C3C",
    boxchatlist: mode === "light" ? "#E6F0FA" : "#222",
    total: mode === "light" ? "#FFFFFF" : "#1A1A1A",
    messageIcons: mode === "light" ? "#888" : "#F3F3F3",
    inputBackground: mode === "light" ? "#FFFFFF" : "#2A2A2A",
    barraSuperior: mode === "light" ? "linear-gradient(to right, #00539B, #0074CC)" : "#1F2B38",
    boxticket: mode === "light" ? "#E6F0FA" : "#3C3C3C",
    campaigntab: mode === "light" ? "#E6F0FA" : "#3A3A3A",
    mediainput: mode === "light" ? "#EDF4FB" : "#1C1C1C",
},

            mode,
        },
        locale
    );

    useEffect(() => {
        const i18nlocale = localStorage.getItem("i18nextLng");
        const browserLocale =
            i18nlocale.substring(0, 2) + i18nlocale.substring(3, 5);

        if (browserLocale === "ptBR") {
            setLocale(ptBR);
        }
    }, []);

    useEffect(() => {
        window.localStorage.setItem("preferredTheme", mode);
    }, [mode]);



    return (
        <ColorModeContext.Provider value={{ colorMode }}>
            <ThemeProvider theme={theme}>
                <QueryClientProvider client={queryClient}>
                  <SocketContext.Provider value={SocketManager}>
                      <Routes />
                  </SocketContext.Provider>
                </QueryClientProvider>
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
};

export default App;
